import { render, staticRenderFns } from "./left-profile.vue?vue&type=template&id=68b5b247&scoped=true"
import script from "./left-profile.vue?vue&type=script&lang=js"
export * from "./left-profile.vue?vue&type=script&lang=js"
import style0 from "./left-profile.vue?vue&type=style&index=0&id=68b5b247&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b5b247",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\mrzhj\\Desktop\\ff\\frontent\\takeout\\www\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68b5b247')) {
      api.createRecord('68b5b247', component.options)
    } else {
      api.reload('68b5b247', component.options)
    }
    module.hot.accept("./left-profile.vue?vue&type=template&id=68b5b247&scoped=true", function () {
      api.rerender('68b5b247', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/user/left-profile.vue"
export default component.exports